import Immutable from 'immutable';

const INITIAL_STATE = Immutable.fromJS({});

export default function (state = INITIAL_STATE, action) {
    state = Immutable.fromJS(state);
    return state.toJS();
}